import { PrivateStackParamList } from "@app/navigationApp/types";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import ScreenWrapper from "@hoc/ScreenWrapper";
import { Theme, ThemedText, ThemedView } from "@app/theme";
import CommonHeader from "@sharedComponents/Header/Header";
import React, { useEffect, useState } from "react";
import KYCVerticalStepper from "@screens/KYCStepper/components/KYCVerticalStepper";
import Button from "@sharedComponents/Button/Button";
import { useTheme } from "@shopify/restyle";
import { useStepperData } from "@hooks/useStepperData";
import { ActivityIndicator, Platform, ScrollView } from "react-native";
import EditLimit from "@screens/KYCStepper/components/EditLimit";
import {
    editLimitAPICall,
    getNextStepId,
    showEditLimitAPICall,
    getEnabledRTA
} from "@screens/KYCStepper/services/service";
import { useAppDispatch, useAppSelector } from "@store/hooks";
import ErrorCard from "@screens/KYCStepper/components/ErrorCard";
import CreditLimitCard from "@screens/KYCStepper/components/CreditLimitCard";
import { usePledgeData } from "@hooks/usePledgeData";
import { getNextRoute } from "@app/navigationApp/navigationUtil";
import KYCStepperShimmer from "./components/KYCStepperShimmer";
import { useIsEnhanceLimit } from "@app/hooks/useIsEnhanceLimit";
import { updatePartnerParams } from "@app/store/slices/platformSlice";
import { getParameters, trackEvent } from "@app/utils";
import KYCAutoRedirect from "./components/KYCAutoRedirect";


type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'KYC_STEPPER'>;


const KYCStepper = ({ navigation, route }: ScreenProps) => {
    const { colors } = useTheme<Theme>()
    const url = Platform.OS === 'web' ? window.location.href : '';
    const params = Platform.OS === 'web' ? getParameters(url) : {};
    const showVoltKycStepper = params?.showVoltKycStepper;
    const { stepperData, isLoading: stepperLoading } = useStepperData();
    const [showEditLimit, setShowEditLimit] = useState(false)
    const userDetails = useAppSelector(state => state?.auth?.userDetails)
    const [showEditLimitCard, setShowEditLimitCard] = useState(false)
    const [editLimitLoader, setEditLimitLoader] = useState(false)
    const [showEditLimitError, setShowEditLimitError] = useState(false)
    const [editLimitErrorMessage, setEditLimitErrorMessage] = useState('')
    const [remainingSteps, setRemainingSteps] = useState(0)
    const [editLimitConfirmLoader, setEditLimitConfirmLoader] = useState(false)
    const [continueButtonLoader, setContinueButtonLoader] = useState(false)
    const { pledgeData, loading: pledgeLimitLoading } = usePledgeData()
    const [creditLimit, setCreditLimit] = useState(0)
    const [isEditLimitVisible, setIsEditLimitVisible] = useState(false)

    const { isFromEnhanceLimit } = useIsEnhanceLimit()
    const dispatch = useAppDispatch()

    const isSkipStepper = Platform.OS === 'web' ? showVoltKycStepper === 'false' : false;




    useEffect(() => {
        if (pledgeData !== null) {
            setCreditLimit(pledgeData.stepResponseObject.requestCreditLimit + pledgeData.stepResponseObject.approvedCreditLimit)
        }
    }, [pledgeData]);


    useEffect(() => {
        if (stepperData) {
            const completedSteps = stepperData.borrowerViewStepperMap.filter(
                (item: any) => item.status === "COMPLETED"
            ).length;

            const remainingSteps = stepperData.borrowerViewStepperMap.length - completedSteps;
            setRemainingSteps(remainingSteps)
        }
    }, [stepperData?.borrowerViewStepperMap]);


    const getEditLimit = async () => {
        const editLimitResponse = await showEditLimitAPICall({
            applicationId: userDetails?.linkedApplications[0]?.applicationId
        })
        setShowEditLimit(editLimitResponse?.data?.isEnabled)
    }


    useEffect(() => {
        
        const fetchEditLimitData = async () => {
            try {
                await Promise.all([
                    getEditLimit(),
                ]);
            } finally {
            }
        };
        
        fetchEditLimitData();
        dispatch(updatePartnerParams({showCall:true}))
    }, []);

    const handleEditLimit = async () => {
        setEditLimitLoader(true)
        setEditLimitConfirmLoader(true)
        try {
            const enabledRTA = await getEnabledRTA({
                applicationId: userDetails?.linkedApplications[0]?.applicationId
            });

            await editLimitAPICall({
                applicationId: userDetails?.linkedApplications[0]?.applicationId
            })

            if(enabledRTA?.mfcFetchStatus === 'IN_PROGRESS') {
                navigation.navigate('MFC_FETCH_EVALUTE_FUNDS')
                return;
            }

            if (enabledRTA?.enabledRtaFlow === "MfCentralFlow") {
                if (Platform.OS === 'web') {
                    navigation.navigate("MFC_FETCH_ANCHOR")
                } else {
                    navigation.reset({
                        index: 0,
                        routes: [{ name: 'HOME' }, { name: 'MFC_FETCH_ANCHOR' }]
                    })
                }
                setEditLimitConfirmLoader(true)
                setShowEditLimitCard(false)

            } else {
                if (Platform.OS === 'web') {
                    navigation.navigate("MF_PLEDGE_PORTFOLIO")
                } else {
                        navigation.reset({
                            index: 0,
                            routes: [{ name: 'HOME' }, { name: 'MF_PLEDGE_PORTFOLIO' }]
                        })
                }
            }
        } catch (error) {
            setEditLimitConfirmLoader(true)
            setTimeout(() => {
            setShowEditLimitError(true)
            },Platform.OS === 'ios' ? 400 : 0)
            setEditLimitLoader(false)
            setShowEditLimitCard(false)
            //@ts-ignore
            setEditLimitErrorMessage(error?.data?.message)
        }

    }

    const handleForwardAction = async () => {
        setContinueButtonLoader(true)
        try {
            const nextStepIdResponse = await getNextStepId({
                applicationId: userDetails?.linkedApplications[0]?.applicationId
            })
            const nextStepId = nextStepIdResponse?.currentStepId
            navigation.navigate(getNextRoute(nextStepId, userDetails?.linkedApplications[0]?.applicationState, userDetails?.linkedApplications[0]?.stepStatusMap))
            setContinueButtonLoader(false)
        } catch (error) {
            //@ts-ignore
            setEditLimitErrorMessage(error?.data?.message)
            setContinueButtonLoader(false)
            setShowEditLimitError(true)
        }

    }

    if(isSkipStepper) {
        return <KYCAutoRedirect autoCallback={handleForwardAction} />
    }

    if (pledgeLimitLoading || stepperLoading) {
        return <KYCStepperShimmer isLoading={pledgeLimitLoading || stepperLoading} />
    }



    return (
        <ScreenWrapper screenName={route?.name} additionalProperties={{ newArchRoute: true }}>
            {<ThemedView flex={1}>
                    <CommonHeader
                        label=""
                        navigation={navigation}
                        pageName={route.name}
                        hideBottomBorder={true}
                    />
                    <ThemedView flex={1} backgroundColor={'bg-surface-primary'}>
                        <ScrollView style={{ padding: 16, display: 'flex', flex: 1 }}>
                            <ThemedText variant={'h5s'} color={'text-primary'} mt={'sm'}>
                                {`Only ${remainingSteps} ${remainingSteps === 1 ? 'step' : 'steps'} remaining!`}
                            </ThemedText>
                            <CreditLimitCard isFromEnhanceLimit = {isFromEnhanceLimit} showEditLimit={showEditLimit} onEditPress={() => {
                                // setShowEditLimitCard(true);
                                trackEvent('KYC_STEPPER_EDIT_LIMIT_CLICKED')
                                setEditLimitConfirmLoader(false)
                                setContinueButtonLoader(false)
                                setIsEditLimitVisible(true)
                            }} creditLimit={creditLimit} />
                            <KYCVerticalStepper stepperData={stepperData?.borrowerViewStepperMap} />
                        </ScrollView>

                        <ThemedView justifyContent={'flex-end'} bottom={0} mt={"sm"}>
                            <ThemedView justifyContent={"flex-end"} borderTopWidth={1} borderColor={"border-primary"} />
                            <ThemedView padding={"lg"}>
                                <Button
                                    eventName='KYC_STEPPER_START'
                                    label="Start"
                                    type="SOLID"
                                    size='MD'
                                    disabled={false}
                                    handlePress={handleForwardAction}
                                    bg={colors['bg-action-primary']}
                                    textColor={colors['text-primary']}
                                    buttonLoader={continueButtonLoader}
                                />
                            </ThemedView>
                        </ThemedView>

                    </ThemedView>
                </ThemedView>
            }
            {
                <EditLimit
                    yesAction={() => {
                        handleEditLimit()
                    }}
                    noAction={() => {
                        setShowEditLimitCard(false)
                    }}
                    colors={colors}
                    loader={editLimitConfirmLoader}
                    isVisible={isEditLimitVisible}
                    setIsVisible={setIsEditLimitVisible}
                />
            }
            {
                showEditLimitError &&
                <ErrorCard visible={true} colors={colors} failedMessage={editLimitErrorMessage} onClose={() => {
                    setShowEditLimitError(false)
                }} />
            }
        </ScreenWrapper>
    )
}

export default KYCStepper

